module.exports = __webpack_public_path__ + "img/telefonica.b3b085d5.png";